import { render, staticRenderFns } from "./AppSwitcherEntry.vue?vue&type=template&id=4eb1202d&scoped=true&"
import script from "./AppSwitcherEntry.vue?vue&type=script&lang=ts&"
export * from "./AppSwitcherEntry.vue?vue&type=script&lang=ts&"
import style0 from "./AppSwitcherEntry.vue?vue&type=style&index=0&id=4eb1202d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb1202d",
  null
  
)

export default component.exports